import React from 'react';
import { useSelector } from 'react-redux';
import { trackGA4PreNav } from '@gumtree/shared/src/util/ga4-shared';
import { RelatedCarousel } from '@gumtree/ui-library';
import { getClickListingDetails } from '@gumtree/shared/src/util/listing-details';
import type { CardSlide } from '@gumtree/ui-library/src/carousel/slider';
import {
    removeTrailingZeros,
    setPriceToZeroIfFreebies,
} from '@gumtree/ui-library/src/utils/currency-service';

import { VipState } from '../../reducers';

interface SimilarAdsProps {
    seeMoreLink?: string;
}

const SimilarAds: React.FC<SimilarAdsProps> = ({ seeMoreLink = '/' }) => {
    const similarAds = useSelector((state: VipState) =>
        state.similarAds
            .map((ad) => ({ type: 'card' as CardSlide['type'], ...ad }))
            .map((ad) => {
                return {
                    ...ad,
                    price: removeTrailingZeros(setPriceToZeroIfFreebies(ad.price, ad.l2CategoryId)),
                };
            })
    );

    const handleItemClick = async (e: React.MouseEvent, slide: any) => {
        e.preventDefault();

        trackGA4PreNav({
            event: 'click_listing',
            linkDomain: window.location.host,
            linkURL: slide.path,
            linkText: undefined,
            linkType: 'card',
            linkSection: 'You may also like',
            listName: 'VIP: Similar Ads',
            clickListingDetails: getClickListingDetails(slide),
        });

        window.location.href = slide.path;
    };

    return (
        <RelatedCarousel
            slides={similarAds}
            title="You may also like..."
            link={{ text: 'See more', href: seeMoreLink }}
            breakpoints={[
                { items: 2, size: 400 },
                { items: 3, size: 600 },
                { items: 6, size: 800 },
            ]}
            endTracking="SimilarAdsEnd"
            linkTracking="SimilarAdsShowMore"
            onItemClick={handleItemClick}
        />
    );
};

export default SimilarAds;
